module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qmusc27-d8ed54debc231ca4d50d35e8f58376d0.jpg";